// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueGtm from 'vue-gtm';

import LoadScript from 'vue-plugin-load-script';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueYouTubeEmbed from 'vue-youtube-embed'

import VModal from 'vue-js-modal/dist/ssr.nocss'
import 'vue-js-modal/dist/styles.css'

import './plugins/table.js'
import service from './services/service.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCookie, faSearch, faComment, faImage, faBroom, faPhone, faMapMarkerAlt, faAt, faStamp, faPaperclip, faEnvelope, faThumbsUp, faAngleDoubleDown, faExternalLinkAlt, faGavel, faBook, faHashtag, faCalendarDay, faCalendarWeek, faAddressCard, faUserGraduate, faKeyboard, faUserTie, faFilePdf, faInfoCircle, faQuestion, faUserCircle, faSignOutAlt, faSign, faCog, faFileSignature, faCheck, faSortAmountDownAlt, faHome, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faGoogle, faTwitter, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faSearch)
library.add(faCookie)
library.add(faAngleDoubleDown)
library.add(faGavel)
library.add(faBook)
library.add(faHashtag)
library.add(faCalendarDay)
library.add(faCalendarWeek)
library.add(faAddressCard)
library.add(faUserGraduate)
library.add(faKeyboard)
library.add(faUserTie)
library.add(faFilePdf)
library.add(faInfoCircle)
library.add(faQuestion)
library.add(faUserCircle)
library.add(faSignOutAlt)
library.add(faCog)
library.add(faFileSignature)
library.add(faCheck)
library.add(faSortAmountDownAlt)
library.add(faThumbsUp)
library.add(faExternalLinkAlt)
library.add(faPaperclip)
library.add(faEnvelope)
library.add(faAt)
library.add(faStamp)
library.add(faMapMarkerAlt)
library.add(faPhone)
library.add(faImage)
library.add(faBroom)
library.add(faComment)
library.add(faHome)
library.add(faArrowLeft)
library.add(faArrowRight)

library.add(faFacebook)
library.add(faGoogle)
library.add(faTwitter)
library.add(faLinkedin)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue);
Vue.use(LoadScript);


Vue.use(VueYouTubeEmbed);

Vue.use(VModal, { dialog: true });

Vue.use(VueGtm, {
  id: ['GTM-5NXXMXL'],
  queryParams: {},
  enabled: true,
  debug: true,
  loadScript: true,
  vueRouter: router,
  ignoredViews: []
});

// router.beforeEach(async (to, from) => {
//   const excludedEndpoints = []
//   if (!(await service.execute('get', 'oauth')))
//     location.href = "https://www.giustup.it";

//     console.log("a")
// })


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  watch: {
    '$route' (to, from) {
      document.title = to.meta.title || 'Your Website'
    }
  }
})

/* My custom scripts */
Date.prototype.ddmmyyyy = function() {
  var yyyy = this.getFullYear();
  var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1);
  var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
  return "".concat(dd).concat("-").concat(mm).concat("-").concat(yyyy);
};





// WEBPACK FOOTER //
// ./src/main.js